import { useCallback } from 'react'
import { mdiDeleteOutline } from '@mdi/js'

import { deleteClaimDeviceThunk } from 'features/networkAi/slice'
import { Inventory } from 'features/networkAi/types'
import {
  mistOrganizationIdSelector,
  mistSiteIdSelector,
} from 'features/networkAi/selectors'
import MobileLabelLine from 'components/MobileWhiteCardLine'
import { makePublicUrl } from 'app/utils/publicUrl'
import { DASH_SYMBOL } from 'app/consts'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import {
  DeleteClaimDeviceButton,
  DeleteClaimDeviceButtonIcon,
  MobileClaimDeviceHeader,
  ClaimDeviceTableImage,
  MobileClaimDeviceHeaderTitle,
  MobileClaimDeviceWrapper,
} from './styles'

interface MobileDeviceListComponentProps {
  values: Record<string, any>
  original: Inventory
}

function MobileDeviceListComponent({
  values,
  original,
}: MobileDeviceListComponentProps) {
  const dispatch = useAppDispatch()
  const organizationId = useAppSelector(mistOrganizationIdSelector)
  const siteId = useAppSelector(mistSiteIdSelector)

  const handleClickToDeleteClaimDevice = useCallback(() => {
    dispatch(deleteClaimDeviceThunk(organizationId, siteId, original.mac))
  }, [dispatch, organizationId, siteId, original.mac])

  return (
    <MobileClaimDeviceWrapper>
      <MobileClaimDeviceHeader>
        <MobileClaimDeviceHeaderTitle>
          <ClaimDeviceTableImage
            src={makePublicUrl(`images/networkIcons/access-points.svg`)}
          />
          {values.name}
        </MobileClaimDeviceHeaderTitle>
        <DeleteClaimDeviceButton onClick={handleClickToDeleteClaimDevice}>
          <DeleteClaimDeviceButtonIcon size={1} path={mdiDeleteOutline} />
        </DeleteClaimDeviceButton>
      </MobileClaimDeviceHeader>
      <MobileLabelLine
        label="Mac Address"
        value={values.mac ? values.mac.match(/.{2}/g).join(':') : DASH_SYMBOL}
      />
      <MobileLabelLine
        label="Model"
        value={values.model ? values.model.toUpperCase() : DASH_SYMBOL}
      />
    </MobileClaimDeviceWrapper>
  )
}

export default MobileDeviceListComponent
